import React from 'react'
import { LeftSide, RightSide, SectionName, SubHeaderContainer, ButtonCreate } from '../../../components/styles/subheader-style'
import { Content } from './style'
import { Outlet, useNavigate } from 'react-router-dom'

const ServicesSubHeader:React.FC = () => {
  const navigate = useNavigate()
  
  const handleCreateClick = () => {
    navigate('create')
  }
  
  return (
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>Serviços</SectionName>
    </LeftSide>
    <RightSide>
      <ButtonCreate onClick={handleCreateClick}>
        + Novo serviço
      </ButtonCreate>
    </RightSide>
  </SubHeaderContainer>
  )
}

const ServicesContent = () => {  
  return (
    <>
    <ServicesSubHeader />
    <Content>
      <Outlet />
    </Content>
    </>
  )
}

export default ServicesContent